module.exports = __webpack_public_path__ + "images/138_1024.jpg";